import React from 'react';
import { Box } from '@material-ui/core';
import NextButton from './nextButton';

const MobileFooter = (props: {
  isLoading: boolean;
  isLoadingParams: boolean;
  getStep?: number;
}) => {
  return (
    <>
      <Box
        component="span"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '16px',
          paddingBottom: '16px',
          paddingRight: '50px',
          paddingLeft: '50px',
        }}
      >
        <NextButton
          isLoading={props.isLoading}
          isLoadingParams={props.isLoadingParams}
          isComplementaryForm={props.getStep === 2}
        />
      </Box>
    </>
  );
};

export default MobileFooter;
